/* eslint-disable camelcase */
export default class Resource {
  registrationIds = []

  createStore (vuexStore, namespace = null, route) {
    // eslint-disable-next-line no-throw-literal
    if (!vuexStore) throw { message: "store is a required param when creating new api Resource store" }

    if (this.constructor.name === "Resource") {
      // eslint-disable-next-line no-throw-literal
      if (!namespace || !route) throw { message: "namespace and route are required params when creating new api Resource store" }

      vuexStore.registerModule(namespace, window.generateLaravelResource({
        route: route
      }))
      this.namespace = namespace
      return
    }

    if (!this.route) {
      // eslint-disable-next-line no-throw-literal
      throw { message: "route is a required api Resource property" }
    }

    this.vuexStore = vuexStore
    this.namespace = namespace || this.constructor.name
    this.template = window.generateLaravelResource({
      route: this.route,
      state: { namespace: this.namespace, ...this.state },
      getters: this.getters,
      mutations: this.mutations,
      actions: this.actions,
      plugins: this.plugins
    })
    vuexStore.registerModule(this.namespace, this.template)
    this.vuexStore.commit(`${this.namespace}/LOAD_SESSIONSTORAGE_FILTERS`)
    this.state = this.vuexStore.state[this.namespace]
    this.mapProperties("state")
    this.mapProperties("getters")
    this.mapProperties("actions")
    this.mapProperties("mutations")
  }

  /**
   *
   * @param {*} type - the type of property to map (actions, mutations, getters, state)
   */
  mapProperties (type) {
    let propertyNames = Object.keys(this.template[type])
    for (let i = 0; i < propertyNames.length; i++) {
      let propertyName = propertyNames[i]
      if (["route", "namespace"].includes(propertyName)) continue
      if (this[propertyName]) {
        // eslint-disable-next-line no-console
        console.error(`Trying to map 2 resource store properties with the same name (${propertyName}), please use different names.`)
      }
      let _this = this
      if (type === "state") {
        Object.defineProperty(this, propertyName, {
          get: function () {
            return _this.state[propertyName]
          }
        })
        continue
      }
      if (type === "getters") {
        Object.defineProperty(this, propertyName, {
          get: function () {
            return _this.vuexStore.getters[`${_this.namespace}/${propertyName}`]
          }
        })
        continue
      }
      if (type === "actions") {
        this[propertyName] = params => {
          return this.vuexStore.dispatch(`${this.namespace}/${propertyName}`, params)
        }
        continue
      }
      if (type === "mutations") {
        this[propertyName] = params => {
          return this.vuexStore.commit(`${this.namespace}/${propertyName}`, params)
        }
      }
    }
  }

  /**
   * Destroys the resource's store module
   */
  destroyStore () {
    this.vuexStore.unregisterModule(this.namespace)
  }

  // Registration ids getter and setter
  get RIds () {
    return this.registrationIds
  }

  set RIds (registrationIds) {
    this.registrationIds = registrationIds
  }
}
